import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import ScrollToTopButton from "./components/feature/ScrollToTopButton";
import { CartProvider } from "./contexts/CartContext";
import { MemberAuthProvider } from "./contexts/MemberAuthContext";
import CartDrawer from "./components/feature/CartDrawer";
import MaintenanceNotice from "./components/feature/MaintenanceNotice";
import SiteHead from "./components/feature/SiteHead";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <MemberAuthProvider>
          <CartProvider>
            <SiteHead />
            <ScrollToTop />
            <ScrollToTopButton />
            <AppRoutes />
            <CartDrawer />
            <MaintenanceNotice />
          </CartProvider>
        </MemberAuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
